const template = require('./Cupons.hbs')
import { format, newPage, formatMoney } from '../../utils'
import { loader } from '../../components/message'
import { estabelecimento } from '../../Estabelecimento/estabelecimento'
import { usuario } from '../../usuario'
import { toast, toastFideliza } from '../../components/message'

export const cupomDesconto = (storeOrder) => {

  const beneficiosFidelidade = estabelecimento.programaFidelidade.beneficios || []
  const beneficiosTipoDesconto = beneficiosFidelidade.filter(beneficio => (beneficio.Pontos >= 0 && beneficio.Produto === 0));
  const unicoBeneficoEhPrimeiraCompra = beneficiosTipoDesconto?.length > 1 ? false : beneficiosFidelidade.some(beneficio => (beneficio.Pontos === 0 && beneficio.Produto === 0)) && estabelecimento.programaFidelidade.cliente.pontos > 0

  newPage({
    id: 'pg-adicionar-cupom',
    appbarTitle: 'Cupons de desconto',
    body: template({
      totalPedido: format.money(storeOrder.valorTotal),
      pontos: estabelecimento.programaFidelidade.cliente ? estabelecimento.programaFidelidade.cliente.pontos : 0,
      programaAtivo: estabelecimento.programaFidelidade.Ativo,
      beneficios: unicoBeneficoEhPrimeiraCompra ? ((estabelecimento.programaFidelidade.Ativo && (beneficiosFidelidade && beneficiosFidelidade?.length > 0)) ? beneficiosFidelidade.filter(beneficio => beneficio.Produto === 0) : []) : beneficiosTipoDesconto.filter(beneficio => beneficio.Pontos > 0),
      existePrimeiroPedido: estabelecimento.programaFidelidade.Ativo ? (beneficiosFidelidade && beneficiosFidelidade.some(beneficio => beneficio.Pontos === 0) && estabelecimento.programaFidelidade.cliente.pontos === 0) : false,
      unicoBeneficoEhPrimeiraCompra: unicoBeneficoEhPrimeiraCompra
    }),
    callback: function () {

      //Função para quando adicionar um cupom de desconto no pedido
      const adicionarCupom = select('#adicionar-cupom')
      adicionarCupom.addEventListener('click', () => {
        validaCupom(storeOrder)
      })

      //Função para quando resgatar um benefício de desconto no pedido
      const cupomFidelidade = select('#adicionar-cupom-fidelidade')
      cupomFidelidade && cupomFidelidade.addEventListener('click', () => {

        const cliente = estabelecimento.programaFidelidade?.cliente;

        const beneficioSelecionado = select('#beneficiosCadastrados')
        const pontosUtilizados = beneficioSelecionado.options[beneficioSelecionado.selectedIndex]?.getAttribute('pontos')?.parseNumber();
        const reaisDesconto = beneficioSelecionado.options[beneficioSelecionado.selectedIndex]?.getAttribute('desconto')?.parseNumber();

        if (beneficioSelecionado && beneficioSelecionado.value.parseNumber() === 0) {
          toastFideliza('Selecione um benefício.')
          return
        }

        if (cliente.pontos < pontosUtilizados) {
          toastFideliza('Você não possui pontos suficientes para resgatar este benefício.')
          return
        }

        //Verifico se o cliente já não está com algum beneficio no pedido (neste caso, possíveis benefícios de itens)
        if (storeOrder && (storeOrder.Itens && storeOrder.Itens.length > 0)) {
          const existeItemFideliza = storeOrder.Itens.filter(item => item.IsItemFidelidade === true);
          if (existeItemFideliza && existeItemFideliza.length > 0) {
            toastFideliza('Você já possui um benefício de item no pedido.')
            return
          }
        }

        //Valido se o valor do desconto é maior que o valor do pedido
        if (storeOrder.valorTotal < reaisDesconto) {
          toastFideliza('O valor de desconto não pode ser maior que o valor dos itens.')
          return
        }

        resgatarBeneficioDesconto(pontosUtilizados, reaisDesconto, cliente, storeOrder)
      })
    }
  })

}

function resgatarBeneficioDesconto(pontos, reaisDesconto, cliente, pedido) {
  const paginaDesconto = select('#pg-adicionar-cupom .app-bar img')
  const descontoWrapper = select('#descontoCpm')
  const descontoElement = select('#valor-desconto')
  const totalElement = select('#total-pedido')
  const nomeCupomWrapper = select('#nomeCpm')
  nomeCupomWrapper && (nomeCupomWrapper.style.display = 'none')

  //Exibo o campo de desconto
  if (descontoWrapper) {
    descontoWrapper.style.display = ''
  }

  //Insiro o valor que foi dado de desconto
  if (descontoElement) {
    descontoElement.textContent = format.money(reaisDesconto)
  }

  //Atualizo o valor do desconto no pedido (ReaisFidelidade e PontosUtilizados)
  pedido.ReaisDesconto = reaisDesconto ?? 0
  pedido.ReaisFidelidade = reaisDesconto ?? 0
  pedido.PontosUtilizados = pontos ?? 0

  //Converto este campo para enviar ao backend
  pedido.ReaisFidelidade = formatMoney(pedido.ReaisFidelidade, true)

  //Calculo o total do pedido novamente.
  if (totalElement) {
    totalElement.textContent = format.money((pedido.valorTotal - pedido.ReaisDesconto) + pedido.TaxaEntrega)
  }

  //Removo a tela de Cupons de desconto
  if (paginaDesconto) {
    select('#pg-adicionar-cupom .app-bar img').click()
  }

  //Caso tenha cliente, atualizo os pontos no html
  if (cliente) {
    const pontosCli = select('#confirmar-pedido #pontos-fidelidade')
    pontosCli.textContent = (cliente.pontos - pontos) < 0 ? 0 : (cliente.pontos - pontos)
  }

  toastFideliza('Benefício resgatado e desconto aplicado!')
}

function validaCupom(storeOrder) {
  var cuponMessageElement = select('#cupom-response')
  var codigoCupom = select('#codigo-cupom')
  var adicionarCupom = select('#adicionar-cupom')

  if (codigoCupom == '') {
    cuponMessageElement.textContent =
      'Digite o código do cupom antes de continuar'
  } else {
    adicionarCupom.innerHTML = loader()
    axios
      .get('Pedido/ValidaCupom', {
        params: {
          cupom: codigoCupom.value
        }
      })
      .then(function ({ data }) {
        if (data.lValid) {
          calculaCupom(data, storeOrder)
        } else {
          cuponMessageElement.textContent = data.msg
        }
      })
      .catch(function (err) {
        console.log(err)
      })
      .finally(function () {
        adicionarCupom.innerHTML = 'Adicionar'
      })
  }
}

export function calculaCupom(data, storeOrder) {
  const totalElement = select('#confirmar-pedido #total-pedido')
  const messageElement = select('#cupom-response')
  const descontoElement = select('#valor-desconto')
  const inputCupom = select('#pg-adicionar-cupom #codigo-cupom')

  let desconto
  if (storeOrder.valorTotal >= data.valorMinimo) {
    storeOrder.IdCupomDesconto = data.idCupom

    let total = storeOrder.valorTotal

    //Calcula o desconto
    if (data.percentual > 0) {
      desconto = total * (data.percentual / 100)
      total -= desconto
    } else if (data.valor > 0) {
      desconto = data.valor
      total -= desconto
    }

    if (total < 0) {
      total = 0
    }

    //Atualizo o valor do desconto no pedido
    storeOrder.ValorDesconto = desconto

    //Zero os possíveis descontos de benefícios do Fideliza
    storeOrder.ReaisDesconto = 0
    storeOrder.PontosUtilizados = 0
    storeOrder.descontoFidelidade = 0

    //Armazena dados do cupom
    storeOrder.cupom = data

    //Armazena o código do cupom
    inputCupom &&
      inputCupom.value != '' &&
      (storeOrder.cupom.nomeCupom = inputCupom.value)

    //Se o pedido é para retirar
    if (storeOrder.CodObsEntrega) {
      totalElement.textContent = format.money(total)
    } else {
      //Se não, soma o frete
      if (
        estabelecimento.entregaGratis > 0 &&
        total >= estabelecimento.entregaGratis
      ) {
        totalElement.textContent = format.money(total)
      } else {
        if (usuario.enderecoSelecionado) {
          total += usuario.enderecoSelecionado.TaxaEntrega
        } else if (usuario.enderecoPrincipal.TaxaEntrega) {
          total += usuario.enderecoPrincipal.TaxaEntrega
        }

        totalElement.textContent = format.money(total)
      }
    }

    if (data.msg == '') {
      const spanDesconto = select('#descontoCpm #valor-desconto')
      const descontoWrapper = select('#descontoCpm')
      const paginaDesconto = select('#pg-adicionar-cupom .app-bar img')
      const spanNomeCupom = select('#nomeCpm #nome-cp-desconto')
      const nomeCupomWrapper = select('#nomeCpm')

      if (spanDesconto) {
        descontoElement.textContent =
          '- ' + format.money(desconto).replace('.', ',')
      }

      if (descontoWrapper) {
        descontoWrapper.style.display = ''
      }
      if (spanNomeCupom && storeOrder.cupom.nomeCupom) {
        spanNomeCupom.textContent = storeOrder.cupom.nomeCupom
      }

      if (nomeCupomWrapper) {
        nomeCupomWrapper.style.display = ''
      }

      if (paginaDesconto) {
        select('#pg-adicionar-cupom .app-bar img').click()
      }
    }
  } else {
    data.msg =
      'O valor mínimo para esse cupom é: ' + format.money(data.valorMinimo)
    messageElement.textContent = data.msg
  }
}

export function validaDescontoFidelidade(pedido) {
  const paginaDesconto = select('#pg-adicionar-cupom .app-bar img')
  if (pedido.ReaisDesconto === 0 || pedido.ReaisDesconto === null) {
    if (paginaDesconto) {
      select('#pg-adicionar-cupom .app-bar img').click()
      toastFideliza('Você não possui pontos suficientes para utilizar o desconto.')
      return
    }
  }

  const spanDesconto = select('#descontoCpm #valor-desconto')
  const descontoWrapper = select('#descontoCpm')
  const descontoElement = select('#valor-desconto')
  const totalElement = select('#total-pedido')
  const nomeCupomWrapper = select('#nomeCpm')
  nomeCupomWrapper && (nomeCupomWrapper.style.display = 'none')
  if (spanDesconto) {
    descontoElement.textContent =
      estabelecimento.programaFidelidade.TipoLancamentoDesconto === 1
        ? pedido.descontoFidelidade.desconto + '%'
        : '- ' + format.money(pedido.descontoFidelidade.desconto)
  }

  if (descontoWrapper) {
    descontoWrapper.style.display = ''
  }

  if (totalElement) {
    totalElement.textContent = format.money(pedido.descontoFidelidade.totalComDesconto + pedido.TaxaEntrega)
  }

  if (paginaDesconto) {
    select('#pg-adicionar-cupom .app-bar img').click()
  }

  const pontos = select('#confirmar-pedido #pontos-fidelidade')
  pontos.textContent = estabelecimento.programaFidelidade.cliente.pontos
}